import React, { useEffect, useState } from "react";
import styled from "styled-components"
import { useDispatch } from "react-redux";
import ReviewAnswerComment from "../molecules/ReviewAnswerComment"
import IconCircle from "../atoms/IconCircle"
import { useCaptureImage   } from "../../utils/capture"
import { showAlert } from "../../reducer/alertSlice";

/**
 * 받은 리뷰 상세 (리뷰 결과 폼)
 * - 일반 사용자 & 관리자 공통 화면
 */
const ReviewResult = ({ ...props }) => {
    const dispatch = useDispatch()
    const { reviewDetailData, reviewResultData, activeReviewee={} } = props;
    const isAdminPage = window.location.pathname.includes('admin')

    // 캡쳐 관련
    const [ref, capture] = useCaptureImage({
        fileName: `[${activeReviewee?.user?.name}] ${reviewDetailData?.title}.png`,
        padding: 20,
        options: { backgroundColor: '#ffffff' },
        onError: err => dispatch(showAlert({
            msg: "이미지 캡처에 실패했습니다:\n" + err.message
        })),
    })
    const [isCapturing, setIsCapturing] = useState(false)
    const handleCapture = async () => {
        try {
            setIsCapturing(true)
            await capture()
        } finally {
            setIsCapturing(false)
        }
    }

    return (
        <CustomReviewResult ref={ref}>
            <div className="title-wrap">
                <div className="title-func-wrap">
                    <h2>{reviewDetailData?.title}</h2>
                    {isAdminPage && !isCapturing && <IconCircle className="bi-camera" style={{ marginLeft: "10px" }} onClick={handleCapture} disabled={isCapturing} />}
                </div>
                <div className="title-desc">{reviewDetailData?.description}</div>
            </div>

            <div className="item-wrap">
                {reviewResultData &&
                    reviewResultData?.map((el, elIdx) => {
                        return (
                            <CustomReviewResultItem className="review-card">
                                <div className="title-wrap">
                                    <div>Q. {el.title}</div>
                                    <div className="answer-desc">{el.description}</div>
                                </div>
                                
                                <div className="question-wrap">
                                    {/* 객관식 */}
                                    {el?.type === "0" &&
                                        el?.option?.map((option, optionIdx) => (
                                            <div key={option.idx}>
                                                <div className="answer-option">
                                                    <img src="/image/icn_answer.svg" /><div className="option-text">{option.text}</div><OptionResponseCount active={option.reviewer.length > 0}>{option.reviewer.length}</OptionResponseCount>
                                                </div>

                                                <AnswerResponseBlock hasChildren={option?.reviewer?.length > 0}>
                                                    {option?.reviewer &&
                                                        option?.reviewer.map((reviewer) => (
                                                            <ReviewAnswerComment reviewer={reviewer.user} comment={reviewer.comment} />
                                                        ))}
                                                </AnswerResponseBlock>
                                            </div>
                                        ))}
                                    {/* 주관식 */}
                                    {el.type === '1' && (
                                        <AnswerResponseBlock hasChildren={true}>
                                            {el.answer?.length > 0
                                                ? el.answer?.map((answer, idx) => (
                                                    <ReviewAnswerComment reviewer={answer.user} comment={answer.answer_text} />
                                                ))
                                                : <span className="answer-empty">-</span>
                                            }
                                        </AnswerResponseBlock>
                                    )}
                                </div>
                            </CustomReviewResultItem>
                        );
                    })}
            </div>
            {isAdminPage && <Score>{activeReviewee?.avg}점</Score>}
        </CustomReviewResult>
    );
};

const CustomReviewResult = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px;

    .title-func-wrap {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .title-wrap {
        display: flex;
        flex-direction: column;
        gap: 10px;
        font-weight: 700;
        font-size: 20px;
        line-height: 130%;
    }
    .item-wrap {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
    .answer-desc {
        font-weight: 500;
        font-size: 15px;
        line-height: 130%;
        color: var(--gray-color);
    }
`;

const CustomReviewResultItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0px;

    .question-wrap {
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-top: 24px;
    }
    .answer-option {
        display: inline-flex;
        gap: 4px;
        align-items: center;
    }
    .option-text {
        font-size: 16px;
        line-height: 150%;
    }
    .answer-empty {
        margin-left: 10px;
    }
`;

const OptionResponseCount = styled.span`
    font-family: 'Gotham';
    weight: 700;
    font-size: 16px;
    line-height: 1.5em;
    color: ${props => props.active ? 'var(--main-point-color)' : '#999999'};
`

const AnswerResponseBlock = styled.div`
    display: ${props => props.hasChildren ? 'flex' : 'none'};
    flex-direction: column;
    gap: 16px;
    margin: 12px 0 0 0;
    padding: 25px 24px;
    background-color: var(--bg-light);
    border-radius: 12px;
`

const Score = styled.div`
    display: flex;
    width: 100%;
    max-width: 400px;
    aspect-ratio: 1/0.4;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    font-size: 6rem;
    font-weight: 600;
    font-family: 'TypoCrayonM';
    background-image: url('/image/bg_score.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
`

export default ReviewResult;